<template>
  <div class="crud">
    <DataTable :value="entities" selectionMode="single" :selection.sync="newStat" @row-select="onRowSelect"
               dataKey="_id" :paginator="true" :rows="15">
      <Column field="name" :header="$t('crud.stat.labels.name')"></Column>
      <Column field="value" :header="$t('crud.stat.labels.value')"></Column>
      <Column field="lastUpdate" :header="$t('crud.stat.labels.lastUpdate')"></Column>
      <template #footer>
        <Button :label="$t('shared.actions.create')" icon="pi pi-plus" @click="createStat" class="p-button-primary" />
      </template>
    </DataTable>

    <Dialog :visible.sync="dialogVisible" :style="{width: '400px'}" :modal="true">
      <template #header>
        <span>{{ $t('crud.stat.modals.titles.' + action) }}</span>
      </template>
      <div>
        <label for="name">{{ $t('crud.stat.labels.name') }}</label>
        <input id="name" v-model="newStat.name" name="name" type="text">
      </div>
      <div>
        <label for="value">{{ $t('crud.stat.labels.value') }}</label>
        <input id="value" v-model="newStat.value" name="value" type="number">
      </div>
      <div>
        <label for="lastUpdate">{{ $t('crud.stat.labels.lastUpdate') }}</label>
        <input id="lastUpdate" v-model="newStat.lastUpdate" name="lastUpdate" type="date">
      </div>
      <template #footer>
        <Button v-if="action === 'update'" :label="$t('shared.actions.delete')" icon="pi pi-trash" @click="deleteStat" class="p-button-danger"></Button>
        <Button :label="$t('shared.actions.save')" icon="pi pi-check" @click="saveStat" class="p-button-success"></Button>
        <Button :label="$t('shared.actions.cancel')" icon="pi pi-times" @click="cancelEdit" class="p-button-secondary"></Button>
      </template>
    </Dialog>
  </div>
</template>

<script>
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import Dialog from "primevue/components/dialog/Dialog";
  import Button from 'primevue/button';
  import Stat from '../../models/stat.model';

  export default {
    name: 'Stats',
    components: {
      Dialog,
      DataTable,
      Column,
      Button
    },
    props: {},
    data: () => {
      return {
        newStat: {},
        dialogVisible: false,
        action: '',
        entityName: ''
      }
    },
    computed: {
      entities() {
        return this.$store.state.stats;
      }
    },
    methods: {
      onRowSelect: function(event) {
        this.action = 'update';
        this.newStat = {...event.data};
        this.dialogVisible = true;
      },
      createStat: function() {
        this.action = 'create';
        this.resetNewStat();
        this.dialogVisible = true;
      },
      deleteStat: function() {
        this.$store.dispatch('removeStat', this.newStat).then((succeed) => {
          if (succeed) {
            this.$toast.add({severity: 'success', summary: this.$t('crud.stat.toasts_msg.summary.delete'),
                             detail: this.$t('crud.stat.toasts_msg.success.delete'), life: 3000});
            this.dialogVisible = false;
            this.resetNewStat();
          } else {
            this.$toast.add({severity: 'error', summary: this.$t('crud.stat.toasts_msg.summary.delete'),
                             detail: this.$t('crud.stat.toasts_msg.fail.delete'), life: 3000});
          }
        });
      },
      saveStat: function () {
        if (
          this.$isNotEmpty(this.newStat.name)
          && this.$isNotEmpty(this.newStat.value) && !isNaN(this.newStat.value)
          && this.$isNotEmpty(this.newStat.lastUpdate)
        ) {
          let dispatch = 'postStat';
          if (this.action === 'update') {
            dispatch = 'updateStat';
          }

          this.$store.dispatch(dispatch, this.newStat).then((succeed) => {
            if (succeed) {
              this.$toast.add({severity: 'success', summary: this.$t('crud.stat.toasts_msg.summary.save'),
                               detail: this.$t('crud.stat.toasts_msg.success.save'), life: 3000});
              this.dialogVisible = false;
              this.resetNewStat();
            } else {
              this.$toast.add({severity: 'error', summary: this.$t('crud.stat.toasts_msg.summary.save'),
                               detail: this.$t('crud.stat.toasts_msg.fail.save'), life: 3000});
            }
          });
        } else {
          this.$toast.add({severity: 'error', summary: this.$t('crud.stat.toasts_msg.summary.validation'),
                           detail: this.$t('crud.stat.toasts_msg.validation.fieldsMissing'), life: 3000
          });
        }
      },
      resetNewStat: function () {
        this.newStat = new Stat({});
      },
      cancelEdit: function () {
        this.dialogVisible = false;
        this.newStat = new Stat({});
      }
    },
    created: function () {
      this.$store.dispatch('fetchAll');
      this.resetNewStat();
      this.entityName = this.$t('crud.stat.stat')
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .crud {
  }
</style>
